import typography from "assets/theme/base/typography";

export const dropdownFontFamily = typography.fontFamily;
export const dropdownFontWeight = typography.fontWeightRegular;

export const dropdownFontStyles = {
  fontFamily: dropdownFontFamily,
  fontWeight: dropdownFontWeight,
  letterSpacing: 0,
};

export const withDropdownFont = (styles = {}) => ({
  ...dropdownFontStyles,
  ...styles,
});
